import $ from 'jquery';
import Popper from 'popper.js';
// import { TweenLite, TweenMax, TimelineLite, TimelineMax, Power0, Power1, Power2, Power3, Power4 } from 'gsap';

// Expose jQuery and Popper globally
window.jQuery = $;
window.$ = $;
window.Popper = Popper;

// GSAP Removed
/*
window.TweenLite = TweenLite;
window.TweenMax = TweenMax;
window.TimelineLite = TimelineLite;
window.TimelineLite = TimelineLite;
window.TimelineMax = TimelineMax;
window.Power0 = Power0;
window.Power1 = Power1;
window.Power2 = Power2;
window.Power3 = Power3;
window.Power4 = Power4;
window.Linear = Power0;
window.Quad = Power1;
window.Cubic = Power2;
window.Quart = Power3;
window.Quint = Power4;
window.Strong = Power4;
*/
